// extracted by mini-css-extract-plugin
export default {"content":"ImportXLS_content__Wu6dt","item":"ImportXLS_item__l3p8k","dropArea":"ImportXLS_dropArea__I95tj","placeHolderShimmer":"ImportXLS_placeHolderShimmer__bIYUg"};